/* Osteo-MAX mobile v3 buy box.

   FORKED FROM gutx-v3-buy-box.js. Root hook is [data-omv3-buybox], which no other section on
   the store carries, so this cannot bind to the Gut X box or to either live buy box even if
   several loaded at once.

   BUILT AS A CONTROL. Osteo-MAX is the same template as Gut X v3 with different content and
   different section wiring, so it isolates whether the reported hairline is in the template or
   in how Gut X is wired. The logic is deliberately IDENTICAL to the Gut X fork: if it differed,
   a difference in outcome would not tell us anything.

   The money path is the proven live one. Variants resolve by SKU OM100/OM200/OM400, subscribe
   prices come from selling_plan_allocations, plan ids from selling_plan_groups. The design
   file's prices are hardcoded and its maths is a mock; never port them.

   Per-day basis is 128 days per gallon at one 1 oz pump daily, the same denominator the live
   Osteo-MAX PDP publishes against: 185.25/128 = 1.45, matching its own data-day value. */
(function () {
  var root = document.querySelector('[data-omv3-buybox]');
  if (!root) return;
  /* BOTH BUY BOXES NOW SHIP ON THE SAME PAGE, gated by breakpoint: v3 renders under 750px,
     the original renders at 750px and up. Only the VISIBLE one may initialise.

     Without this guard both scripts run and both assign window.GX_GET_SELECTION, so whichever
     loaded last owns it regardless of which box the customer can actually see. That global is
     read by the OCU bridge to decide what to add to the cart. offsetParent is null for a
     display:none element, which is the cheapest reliable visibility test here. */
  if (!root.offsetParent) return;


  var money = function (cents) { return '$' + (Number(cents) / 100).toFixed(2); };

  /* Under a dollar reads in cents, at or over a dollar in dollars. Designer's rule: 84 cents
     lands harder than $0.84, but $1.05 cannot be 105 cents. Rounding matches money() so the
     two can never disagree by a cent. */
  var perDay = function (cents) {
    var v = Number(cents) / 100;
    return v < 1 ? Math.round(v * 100) + '¢' : '$' + v.toFixed(2);
  };

  /* 128 days per gallon: one 1 oz pump daily at maintenance, 128 fl oz per gallon. This is the
     denominator the desktop PDP already publishes against (107.83/128 = 0.84, 170.05/256 = 0.66,
     322.05/512 = 0.63), which is the check that it is the right basis. The loading phase is 14
     days at 2 pumps and is excluded on purpose: the buy box footnote says "at the maintenance
     dose", which is what makes the arithmetic honest rather than optimistic. */
  var DAYS_PER_GALLON = 128;

  var state = { tier: '1', cadence: '90', mode: 'one' };  // matches the design's default state

  var sizeBtns = root.querySelectorAll('[data-gx-size] button');
  var cadenceBtns = root.querySelectorAll('[data-gx-cadence] button');
  var modeLabels = root.querySelectorAll('[data-gx-mode]');

  function activeTierBtn() {
    return root.querySelector('[data-gx-size] button[data-tier="' + state.tier + '"]');
  }
  function tier1OneTime() {
    var b = root.querySelector('[data-gx-size] button[data-tier="1"]');
    return b ? Number(b.getAttribute('data-onetime')) : 0;
  }
  function subPrice(btn) {
    var v = btn.getAttribute('data-sub' + state.cadence);
    if (v == null) v = btn.getAttribute('data-sub90');
    return Number(v || 0);
  }
  function qtyLineSub(tier) {
    if (tier === '1') return '1 Gallon of Osteo-MAX + 1 pump';
    if (tier === '2') return '2 Gallons of Osteo-MAX + 2 pumps';
    return '4 Gallons of Osteo-MAX + 2 pumps';
  }
  function qtyLineOne(tier) {
    if (tier === '1') return '1 Gallon of Osteo-MAX + 1 pump';
    if (tier === '2') return '2 Gallons of Osteo-MAX + 2 pumps';
    return '4 Gallons of Osteo-MAX + 2 pumps';
  }

  var $ = function (sel) { return root.querySelector(sel); };
  var setText = function (sel, v) { var e = $(sel); if (e) e.textContent = v; };
  var setHTML = function (sel, v) { var e = $(sel); if (e) e.innerHTML = v; };
  var show = function (sel, on, disp) { var e = $(sel); if (e) e.style.display = on ? (disp || '') : 'none'; };

  function render() {
    var btn = activeTierBtn();
    if (!btn) return;
    var name = btn.getAttribute('data-name');
    var oneTime = Number(btn.getAttribute('data-onetime'));
    var oneStrike = Number(btn.getAttribute('data-onetime-strike') || 0);
    var strike = Number(btn.getAttribute('data-strike') || 0);
    var sub = subPrice(btn);
    var bonus = btn.getAttribute('data-bonus');
    var perk = btn.getAttribute('data-perk');
    var tierQty = Number(state.tier);

    // Subscribe savings badge = savings vs the same gallons bought at 1-gallon retail.
    var t1 = tier1OneTime();
    var pct = t1 ? Math.round((1 - (sub / tierQty) / t1) * 100) : 0;
    /* The word "Save" is wrapped so CSS can drop it under 375px. At 360-370 (most Samsungs) the
       badge and title together want 187px against a 175px column, and the two wrap into 28px of
       extra height that pushes Add to Cart below the fold. Hiding one word buys 25px in a single
       move, and "Subscribe & Save [20%]" still reads correctly. Not solved with nowrap: the
       designer's standing rule, and the cause of every headline overflow on this site, is never
       to put nowrap on a block that cannot shrink. */
    setHTML('[data-gx-mode-badge]', '<i class="bw">Save </i>' + pct + '%');

    // Mode prices
    setText('[data-gx-mode-sub-now]', money(sub));
    var subStrikeEl = $('[data-gx-mode-sub-strike]');
    if (subStrikeEl) {
      subStrikeEl.textContent = strike ? money(strike) : '';
      subStrikeEl.style.display = strike ? '' : 'none';
    }
    setText('[data-gx-mode-one-now]', money(oneTime));
    var oneStrikeEl = $('[data-gx-mode-one-strike]');
    if (oneStrikeEl) {
      oneStrikeEl.textContent = oneStrike ? money(oneStrike) : '';
      oneStrikeEl.style.display = oneStrike ? '' : 'none';
    }

    // Per-day rate on both cards, tracking the selected size (v3 only).
    var denom = DAYS_PER_GALLON * tierQty;
    setText('[data-gx-perday-sub]', perDay(sub / denom) + ' per horse, per day');
    setText('[data-gx-perday-one]', perDay(oneTime / denom) + ' per horse, per day');

    // Subscribe card subline: the dollar saving at 1 gallon, the gift at 2 and 4 where it wins.
    setText('[data-gx-perk]', perk || '');

    modeLabels.forEach(function (l) {
      l.setAttribute('data-on', l.getAttribute('data-gx-mode') === state.mode ? 'true' : 'false');
    });

    // Size tiles: the saving shows in subscribe mode only, the name alone in one-time.
    sizeBtns.forEach(function (b) {
      b.setAttribute('data-on', b.getAttribute('data-tier') === state.tier ? 'true' : 'false');
      var save = b.querySelector('[data-gx-save]');
      if (save) {
        save.style.display = state.mode === 'sub' ? '' : 'none';
        save.textContent = 'Save ' + money(b.getAttribute('data-save'));
      }
    });
    setHTML('[data-gx-size-label]', name);

    // Step 3 does not exist in one-time mode, so the default state shows two numbered steps.
    show('[data-gx-cadence-field]', state.mode === 'sub');
    cadenceBtns.forEach(function (b) {
      b.setAttribute('data-on', b.getAttribute('data-cadence') === state.cadence ? 'true' : 'false');
    });
    setHTML('[data-gx-cadence-label]', state.cadence);

    var price = state.mode === 'sub' ? sub : oneTime;
    setText('[data-gx-cta-label]', state.mode === 'sub' ? 'Subscribe & Save' : 'Add to Cart');
    setText('[data-gx-cta-price]', money(price));
    show('[data-gx-sub-only]', state.mode === 'sub', 'inline-flex');

    // Includes list
    var isSub = state.mode === 'sub';
    setText('[data-gx-inc-head]', isSub ? ('Your ' + name + ' subscription includes') : 'Your one-time order includes');
    var li = function (html) { return '<li><span class="ic"></span><span>' + html + '</span></li>'; };
    var items = isSub
      ? li('<b>' + qtyLineSub(state.tier) + '</b>')
        + (bonus ? li('<b>' + bonus + '</b><span class="tag">*New Subscription Offer</span>') : '')
        + li('<b>$20,000 Colic Care Coverage Program</b>')
        + li('<b>Up to 4 month supply per gallon</b>')
      : li('90-Day Money-Back Guarantee')
        + li('Free Equine Nutritionist Consultation')
        + li('Up to <b>4 month supply</b> per gallon')
        + li(qtyLineOne(state.tier));
    setHTML('[data-gx-inc-list]', items);
    show('[data-gx-inc-foot]', isSub && !!bonus);

    // Sticky mobile bar
    setHTML('[data-gx-mbb-mode]', 'Osteo-MAX &middot; ' + name);
    setText('[data-gx-mbb-now]', money(price));
    var mbbStrike = $('[data-gx-mbb-strike]');
    if (mbbStrike) {
      var showStrike = isSub && strike;
      mbbStrike.textContent = showStrike ? money(strike) : '';
      mbbStrike.style.display = showStrike ? '' : 'none';
    }
    setText('[data-gx-mbb-cta]', isSub ? 'Subscribe & Save' : 'Add to Cart');

    renderGallery();
  }

  // ----- events -----
  sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () { state.tier = b.getAttribute('data-tier'); shot = 0; render(); });
  });
  cadenceBtns.forEach(function (b) {
    b.addEventListener('click', function () { state.cadence = b.getAttribute('data-cadence'); render(); });
  });
  modeLabels.forEach(function (l) {
    l.addEventListener('click', function () { state.mode = l.getAttribute('data-gx-mode'); render(); });
  });
  var switchSub = $('[data-gx-switch-sub]');
  if (switchSub) switchSub.addEventListener('click', function () { state.mode = 'sub'; render(); });

  // ----- add to cart (unchanged from live) -----
  var plans = {};
  try { plans = JSON.parse(root.getAttribute('data-plans') || '{}'); } catch (e) {}

  window.GX_GET_SELECTION = function () {
    var b = activeTierBtn();
    if (!b) return null;
    return {
      variantId: b.getAttribute('data-variant-id'),
      sellingPlanId: state.mode === 'sub' ? (plans[state.cadence] || null) : null
    };
  };

  function addToCart() {
    var btn = activeTierBtn();
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    var sellingPlan = state.mode === 'sub' ? plans[state.cadence] : null;
    window.dispatchEvent(new CustomEvent('gx:add-to-cart', { detail: {
      items: { 'osteo-max': Number(state.tier) },
      variantId: variantId, sellingPlanId: sellingPlan,
      label: btn.getAttribute('data-name') + ' Osteo-MAX', mode: state.mode, cadence: state.cadence
    } }));
    if (!window.__gxCartModule) {
      var line = { id: Number(variantId), quantity: 1 };
      if (sellingPlan) line.selling_plan = Number(sellingPlan);
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [line] })
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.href = '/cart';
      }).catch(function () {});
    }
  }
  root.querySelectorAll('[data-gx-add-cta]').forEach(function (b) {
    b.addEventListener('click', addToCart);
  });

  /* ----- gallery -----
     Four slides. Slide 2 is the product cutout and tracks the selected size, so its src comes
     off the active size button rather than the slide list. */
  var shot = 0;
  var slides = [];
  try { slides = JSON.parse(root.getAttribute('data-slides') || '[]'); } catch (e) {}
  var shotImg = $('[data-gx-shot-img]');
  var shotCt = $('[data-gx-shot-ct]');
  var dotsEl = $('[data-gx-dots]');

  function renderGallery() {
    if (!shotImg || !slides.length) return;
    var g = slides[shot] || slides[0];
    var tierBtn = activeTierBtn();
    var src = g.tierImg ? (tierBtn && tierBtn.getAttribute('data-img')) : g.src;
    if (src) shotImg.setAttribute('src', src);
    shotImg.className = g.contain ? 'contain' : '';
    shotImg.style.objectPosition = g.pos || 'center';
    if (g.alt) shotImg.setAttribute('alt', g.alt);
    if (shotCt) shotCt.textContent = (shot + 1) + ' / ' + slides.length;
    if (dotsEl) {
      dotsEl.innerHTML = slides.map(function (s, i) {
        return '<button type="button" data-i="' + i + '" data-on="' + (shot === i) + '" aria-label="Image ' + (i + 1) + '"></button>';
      }).join('');
      dotsEl.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function (e) { e.stopPropagation(); shot = Number(b.getAttribute('data-i')); renderGallery(); });
      });
    }
  }
  var shotWrap = $('[data-gx-shot]');
  if (shotWrap) shotWrap.addEventListener('click', function () { shot = (shot + 1) % slides.length; renderGallery(); });

  // ----- sticky mobile buy bar -----
  var cta = root.querySelector('[data-gx-cta-label]');
  var ctaBtn = cta && cta.closest('button');
  var mbar = $('[data-gx-mobile-bar]');
  if (ctaBtn && mbar && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      mbar.setAttribute('data-show', entries[0].isIntersecting ? 'false' : 'true');
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    io.observe(ctaBtn);
  }

  // ----- ship-by countdown (next 3pm CT) + ZIP transit (unchanged from live) -----
  var shipLine = $('[data-gx-ship-line]');
  var zipInput = $('[data-gx-ship-zip]');
  var zipOk = $('[data-gx-ship-ok]');
  function zipTransit(z) {
    if (!/^\d{5}$/.test(z)) return 3;
    return ({ '7': 2, '6': 2, '4': 3, '5': 3, '3': 3, '2': 4, '8': 4, '0': 4, '1': 4, '9': 5 })[z[0]] || 3;
  }
  var isBiz = function (d) { return d.getDay() >= 1 && d.getDay() <= 5; };
  var addBiz = function (date, n) { var d = new Date(date); while (n > 0) { d.setDate(d.getDate() + 1); if (isBiz(d)) n--; } return d; };
  function renderShip() {
    if (!shipLine) return;
    var days = zipTransit(zipInput ? zipInput.value : '');
    var c = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    var cutoff = new Date(c); cutoff.setHours(15, 0, 0, 0);
    if (c >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
    var todays3pm = new Date(c); todays3pm.setHours(15, 0, 0, 0);
    var shipDate = (isBiz(c) && c < todays3pm) ? new Date(c) : addBiz(c, 1);
    var delivery = addBiz(shipDate, days);
    var dShort = delivery.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    var ms = cutoff - c;
    var h = Math.floor(ms / 3600000); ms -= h * 3600000;
    var m = Math.floor(ms / 60000);
    shipLine.innerHTML = 'FREE delivery <b>' + dShort + '</b>. Order within <b>' + (h > 0 ? h + 'h ' : '') + m + 'm</b>';
  }
  if (zipInput) {
    try { zipInput.value = localStorage.getItem('gx_zip') || ''; } catch (e) {}
    zipInput.addEventListener('input', function () {
      zipInput.value = zipInput.value.replace(/\D/g, '').slice(0, 5);
      var ok = /^\d{5}$/.test(zipInput.value);
      if (zipOk) zipOk.style.display = ok ? '' : 'none';
      try { if (ok) localStorage.setItem('gx_zip', zipInput.value); } catch (e) {}
      renderShip();
    });
    if (/^\d{5}$/.test(zipInput.value) && zipOk) zipOk.style.display = '';
  }
  renderShip();
  setInterval(renderShip, 30000);

  render();
})();
